module.exports = __webpack_public_path__ + "img/Amur.af46cc29.jpg";